<template>
  <div class="state-filter">
    <div
      class="state-filter__placeholder state-filter-placeholder"
      :class="{ active: showDropdown }"
      @click="toggleDropdown"
    >
      <span v-if="filterStates.length > 0" class="state-filter-placeholder__title">{{ trans('filter.state.placeholder') }}</span>
      <div
        v-if="filterStates.length > 0"
        class="state-filter-placeholder__selected placeholder-selected"
      >
        <div class="placeholder-selected__first selected-first">
          <div class="selected-first__name" :class="{ 'smaller-width': filterStates.length > 1 }">
            {{ getStateLabel(filterStates[0]) }}
          </div>
          <div
            v-if="filterStates.length > 1"
            class="selected-first__number"
          >
            {{ trans('global.plus') }}{{ filterStates.length - 1 }}
          </div>
        </div>
        <div
          v-if="filterStates.length > 0"
          class="placeholder-selected__empty"
          @click="emptySelectedList"
        />
      </div>
      <div v-else>
        {{ trans('filter.state.placeholder_empty') }}
      </div>
      <span class="state-filter-placeholder__caret" />
    </div>

    <div
      v-if="showDropdown"
      class="state-filter__dropdown state-filter-dropdown"
      @click="$event.stopPropagation()"
    >
      <ul>
        <li
          v-for="state in filterableStates"
          :key="state"
          class="input-checkbox"
        >
          <input
            :id="'state_' + state"
            type="checkbox"
            :disabled="isLoading"
            :checked="isChecked(state)"
            :value="state"
            @change="updateList(state)"
          >
          <label :for="'state_' + state">
            <span>{{ getStateLabel(state) }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { useOfferListStore } from '@stores/useOfferListStore';
import { eventBus } from '@tools/event-bus';
import { trans, transchoice } from '@elements/translation';
import { storeToRefs } from 'pinia';
import { OfficeStateEnum } from './office-state-enum';

export default {
  setup() {
    const store = useOfferListStore();
    const { filterableStates } = store;
    const { isLoading, filterStates } = storeToRefs(store);
    return {
      isLoading,
      filterableStates,
      filterStates,
    };
  },
  data() {
    return {
      showSaveConfirmed: false,
      showDropdown: false,
      prefill: false,
    };
  },
  mounted() {
    /**
     * This listener purpose is to handle click outside of the button
     */
    window.addEventListener('click', () => {
      if (this.showDropdown) {
        this.showDropdown = false;
      }
    });
    eventBus.addEventListener('filters-modal-click-outside', this.handleCloseDropdown);
    eventBus.addEventListener('offer-close-modale', this.handleCloseDropdown);
  },
  beforeUnmount() {
    eventBus.removeEventListener('filters-modal-click-outside', this.handleCloseDropdown);
  },
  methods: {
    trans,
    handleCloseDropdown() {
      if (this.showDropdown) {
        this.showDropdown = false;
      }
    },
    isChecked(state) {
      return this.filterStates.includes(state);
    },
    toggleDropdown(event) {
      if (event) {
        event.stopPropagation();
      }

      if (this.showDropdown) {
        this.showDropdown = false;
        return;
      }
      eventBus.dispatchEvent(new Event('offer-close-modale'));
      this.showDropdown = true;
    },
    emptySelectedList() {
      this.filterStates = [];
    },
    getStateLabel(state) {
      const key = OfficeStateEnum.DRAFT_LOOK_ALIKE.includes(state) ? OfficeStateEnum.DRAFT : state;
      return transchoice(`offer.state.${key}`, { count: 1 });
    },
    updateList(clickedState) {
      if (this.filterStates.includes(clickedState)) {
        const index = this.filterStates.findIndex((state) => state === clickedState);
        this.filterStates.splice(index, 1);
        return;
      }
      this.filterStates.push(clickedState);
    },
  },
};
</script>
